import { ReactComponent as SyncOutline } from "./icons/sync-outline.svg";
import "./Header.css";

const Header = ({ onGenerate, disableGeneration }) => {
	return (
		<header className="header">
			<h1>JIRA Generator</h1>
			<button
				className="header-button"
				onClick={onGenerate}
				type="button"
				disabled={disableGeneration}
			>
				<SyncOutline width={14} />
				<span className="header-button-text">Generate</span>
			</button>
		</header>
	);
};

export default Header;
